import render from '../../designs/paper';

import './styles/style.scss';

render();
